import { API } from "./apiAuth";

// Function to get available exchanges
const getAvailExc = async () => {
  try {
    const response = await API.get("connected-exchanges");
    return response.data;
  } catch (error) {
    console.error("Error get available exchanges", error);
    throw error;
  }
};

// Function to get alarm sound types
const getAlarmSound = async () => {
  try {
    const response = await API.get("alarm-sounds");
    return response.data;
  } catch (error) {
    console.error("Error get alarm sound types:", error);
    throw error;
  }
};

// Function to get seleted alarm coins
const getSeletedCoins = async () => {
  try {
    const response = await API.get("insight-alarm-coins");
    return response.data;
  } catch (error) {
    console.error("Error get insight alarm coins:", error);
    throw error;
  }
};

// Function to set seleted alarm coins
const setSeletedCoins = async (coins) => {
  try {
    await API.put("insight-alarm-coins", coins);
  } catch (error) {
    console.error("Error set insight alarm coins:", error);
    throw error;
  }
};


//  Alarm Public Methods
const getAlarms = async (url) => {
    try {
      const response = await API.get(url);
      return response.data;
    } catch (error) {
      console.error(`Error get ${url} alarm:`, error);
      throw error;
    }
};

const patchActive = async (url) => {
    try {
        await API.patch(url);
      } catch (error) {
        console.error(`Error patch ${url} active:`, error);
        throw error;
      }
};

const patchSound = async (url) => {
    try {
      await API.patch(url);
    } catch (error) {
        console.error(`Error patch ${url} sound:`, error);
      throw error;
    }
};

const getHistory = async (url) => {
    try {
        const response = await API.get(url);

        // let response
        // // console.log('url', url)
        // if (url == 'score-alarm-histories' || url == 'volatility-alarm-histories') {
        //   response = await APITest.get(url);

        // }
        // else {
        //   response = await API.get(url);
        // }

        return response.data;
    } catch (error) {
        console.error(`Error get ${url} history alarms:`, error);
        throw error;
    }
};



export default {
  getAvailExc,
  getAlarmSound,
  getSeletedCoins,
  setSeletedCoins,
  getAlarms,
  patchActive,
  patchSound,
  getHistory
};
